<template>
    <div class="grid-container">
        <PlanLockOverlay v-for="(note, index) in Notes" :key="index" :locked="!!note.lockedByPlan"
            item-type="note">
            <Card class="Card p-4 h-full">
                <template #content>
                    <div class="flex flex-column align-item-center justify-content-center gap-2 text-sm ">
                        <div class="flex justify-content-start gap-2 ">
                            <div class="flex flex-column justify-content-start gap-2  pb-2 ">
                                <span class="note-title">{{ note.title }}</span>
                                <span class="Paragraph-Medium"> {{ note.subject }}</span>
                                <span class="Paragraph-Medium"> {{ formatToDisplayDate(note.created_at) }}</span>
                                <span class="Label note-text" v-html="note.note"></span>
                            </div>
                        </div>
                        <!-- <div class="flex justify-content-center gap-2">
                            <span class="Caption note-text" v-html="note.note"></span>
                        </div> -->
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-content-center gap-2 mt-3">
                        <Button label="View Note" class="orange-button-small" @click="$emit('view-note', note)" />
                    </div>
                </template>
            </Card>
        </PlanLockOverlay>
    </div>
</template>
<script setup>
import Card from "primevue/card";
import Button from "primevue/button";
import { defineProps, defineEmits } from "vue";
import { formatToDisplayDate } from "@/utils/cleanups";
import PlanLockOverlay from "@/components/PlanLockOverlay.vue";

defineProps({
    Notes: {
        type: Array,
        required: true
    }
});

defineEmits(['view-note']);

</script>
<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
    gap: 3rem;
    padding: 0 1rem 1rem 1rem;
    /* Added padding for spacing */
}

.Card {
    /* background-color: var(--teal-800); */
    border-radius: 4px;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.teal-button {
    padding: 8px 16px 8px 16px;
    height: 30px;
    font-size: 0.75rem;
}

.p-button-danger {
    padding: 10px 16px 10px 16px;
    height: 30px;
}

.Caption {
    color: var(--gray-700);
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

.note-title {
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: 0.3px;
    display: block;
    padding-bottom: 0.5rem;
    text-align: left;
    color: black;
}

.note-text {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    min-height: 6em;
}
</style>